import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useCanConfigure } from '../../stores/auth.store.js';
import { useActiveModules } from './active-modules';

/** Caminho do gerenciador de ferramentas já com a ferramenta escolhida. */
export const toolPreparationPath = (moduleId: string) =>
  `/modulos?ferramenta=${encodeURIComponent(moduleId)}`;

/**
 * Link para outra ferramenta. Se ela estiver ativa para você, abre o destino; se a empresa a tem mas o perfil não alcança, avisa; se não está ativa, leva à preparação
 * real (gerenciador já na ferramenta) ou orienta quem não pode ativar, sem link morto.
 */
export function ToolLink({
  moduleId,
  to,
  toolName,
  className,
  children,
}: {
  moduleId: string;
  to: string;
  toolName: string;
  className?: string;
  children: ReactNode;
}) {
  const modules = useActiveModules();
  const canConfigure = useCanConfigure();
  if (!modules.ready || modules.isActive(moduleId))
    return (
      <Link className={className} to={to}>
        {children}
      </Link>
    );
  if (modules.isInstalled(moduleId) === true)
    return (
      <span>
        {children} (seu perfil não acessa {toolName}; peça acesso ao dono ou administrador)
      </span>
    );
  if (!canConfigure)
    return (
      <span>
        {children} (peça ao dono ou administrador para ativar {toolName})
      </span>
    );
  return (
    <Link className={className} to={toolPreparationPath(moduleId)}>
      Ativar {toolName} para abrir {children}
    </Link>
  );
}
